import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {ErrorType} from '@shared/models/ErrorTypes';
import {GlobalMessageType} from '@spartacus/core';
import {of} from 'rxjs';
import {catchError, concatMap, map} from 'rxjs/operators';
import {ShippingBacklogOverviewResponse} from '../../model/shipping-backlog.model';
import {ShippingBacklogOverviewConnector} from '../../occ/connectors/shipping-backlog-overview.connector';
import {ShippingBacklogOverviewActions} from '../actions';
import {EfaGlobalMessageService} from '@shared/services/efa-global-message.service';

@Injectable()
export class ShippingBacklogOverviewEffect {
  loadShippingBacklogOverview$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ShippingBacklogOverviewActions.loadShippingBacklogOverview),
      concatMap((action) =>
        this.connector.loadOverview(action.request).pipe(
          map((response: ShippingBacklogOverviewResponse) => {
            return ShippingBacklogOverviewActions.loadShippingBacklogOverviewSuccess({ response });
          }),
          catchError((error: ErrorType) => {
            this.globalMessageService.add(
              {
                key: 'shippingBacklog.globalMessage.loadingShippingBacklogOverviewFailure',
              },
              GlobalMessageType.MSG_TYPE_ERROR
            );
            return of(ShippingBacklogOverviewActions.loadShippingBacklogOverviewFailure({ errorResponse: error }));
          })
        )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private connector: ShippingBacklogOverviewConnector,
    private globalMessageService: EfaGlobalMessageService
  ) {
  }
}
